import React, { useState } from "react";
import styles from "./OrderHistory.module.css";
import SubmitButton from "../../../../../components/submitButton/SubmitButton";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";


const OrderHistory = () => {
const navigate = useNavigate();

       const columns = [
        {
            title: "Order ID",
            dataIndex: "OrderID",
            key: "OrderID",
        },
        {
            title: "Order Date",
            dataIndex: "OrderDate",
            key: "OrderDate",
        },
        {
            title: "Fulfillment Status",
            key: "FulfillmentStatus",
            dataIndex: "FulfillmentStatus",
        },
          {
            title: "Due Date",
            dataIndex: "DueDate",
            key: "DueDate",
        },
        {
            title: "",
            key: "action",
            dataIndex: "Button",
            render: (text, record) => record.Button,
        },

    ];

    const data = [
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            DueDate: "Aug 20, 2025 ",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
              onClick={() => navigate("/AdminCustomerManagement/OrderHistoryDetails")}
                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            DueDate: "Aug 20, 2025 ",

            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                           onClick={() => navigate("/AdminCustomerManagement/OrderHistoryDetails")}

                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            DueDate: "Aug 20, 2025 ",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                           onClick={() => navigate("/AdminCustomerManagement/OrderHistoryDetails")}

                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            FulfillmentStatus: "Delivered",
            DueDate: "Aug 20, 2025 ",

            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                           onClick={() => navigate("/AdminCustomerManagement/OrderHistoryDetails")}

                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            FulfillmentStatus: "Delivered",
            DueDate: "Aug 20, 2025 ",

            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                           onClick={() => navigate("/AdminCustomerManagement/OrderHistoryDetails")}

                />
        },

    ];

  return (
    <div>
       <div className={styles.mainCont}>

            <div className={styles.TableDiv}>
                <Table
                    scroll={{ x: true }}
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    rowKey="No"
                />
            </div>

        </div>
      
    </div>
  )
}

export default OrderHistory
